<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>شارژ آنلاین</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="3">
                                    <label>کاربر</label>
                                    <model-select :options="users" v-model="form.user_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.user_id.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.billing_type.val"
                                        :description="form.billing_type.inv"
                                        label="نوع پرداخت"
                                        :options="options"
                                        placeholder="انتخاب کنید"
                                        @change="form.billing_type.val=$event.target.value"
                                    />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.fee.val" :description="form.fee.inv" dir="ltr" label="مبلغ (ریال)" />
                                </CCol>
                                <CCol sm="3">
                                    <CTextarea
                                    v-model="form.billing_details.val" :description="form.billing_details.inv"
                                    label="توضیحات" rows="3" @keyup.enter="access=false" />
                                </CCol>
                            </CRow>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" class="ml" color="primary"> افزودن</CButton>
                            <CButton @click="validator();pay_billing()"
                                v-if="form.billing_type.val == '1'" color="primary"> افزودن و پرداخت</CButton>
                        </div>    
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data() {
        return {
            form: {
				user_id: {val: '', inv: '', v: { req: true, max: 8 }},
                billing_type: {val: '', inv: '', v: { req: true, max: 8 }},
                fee: {val: '', inv: '', v: { req: true, max: 64 }},
                billing_details: {val: '', inv: '', v: { req: true, max: 512 }},
			},
            disable: false,
            users: [],
            options: [],
            id: 0,
            access: true,
        }
    },
    watch: {
        'form.fee.val':{
            handler(){
                this.form.fee.val = String(this.form.fee.val).replace(/,/g, '');
                this.form.fee.val = String(this.form.fee.val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        }
    },
    mounted() {
        this.get_users();
        if(this.$store.state.perms.can_add_bill_type_add_pay_online){
            this.options.push({value: '1', label: 'پرداخت آنلاین'});
        }
        if(this.$store.state.perms.can_add_bill_type_add_decrease_account_balance){
            this.options.push({value: '0', label: 'برداشت از موجودی'});
        }
        if(this.$store.state.perms.can_add_bill_type_add_fish){
            this.options.push({value: '4', label: 'ثبت فیش'});
        }
        if(this.$store.state.perms.can_add_bill_type_add_increase_account_balance){
            this.options.push({value: '5', label: 'افزایش موجودی'});
        }
	},
    methods: {
        get_users(){
            this.axios.get('users/?type=add_bill')
            .then(res => {
                res.data.map(val => {
                    this.users.push({value: val.id, text: `${val.id} - ${val.name}`})
                });
            })
        },
        pay_billing(){
            if(this.access){
                if(this.disable == false){
                    const data = new FormData();
                    for (const key in this.form){
                        if(key == 'fee'){
                            data.set(key, String(this.form[key].val).replace(/,/g, ''));
                        } else {
                            data.set(key, this.form[key].val);
                        }
                    }
                    this.axios.post('user_billings/', data)
                        .then(res => {
                            this.$notify({
                                group: 'foo',
                                type: 'success',
                                text: 'افزودن با موفقیت انجام شد.'
                            });
                            for (const key in this.form){
                                this.form[key].val = '';
                            }
                            const data = new FormData();
                            data.set('id', res.data.id);
                            this.axios.post('pay_bills/', data)
                                    .then(res => {
                                        this.$notify({
                                            group: 'foo',
                                            type: 'success',
                                            text: 'در حال انتقال به درگاه پرداخت...'
                                        });
                                        window.location = res.data.data.PaymentUrl;
                                    })
                                    .catch(() => {
                                        this.$notify({
                                            group: 'foo',
                                            type: 'error',
                                            text: 'انتقال به درگاه پرداخت انجام نشد! لطفا مجددا تلاش کنید.'
                                        });
                                    })
                        })
                        .catch(() => {
                            this.$notify({
                                group: 'foo',
                                type: 'error',
                                text: 'خطا! لطفا مجددا تلاش کنید.'
                            });
                        })
                }
            }
            this.access = true;
        },
        submit(){
            if(this.access){
                if(this.disable == false){
                    const data = new FormData();
                    for (const key in this.form){
                        if(key == 'fee'){
                            data.set(key, String(this.form[key].val).replace(/,/g, ''));
                        } else {
                            data.set(key, this.form[key].val);
                        }
                    }
                    this.axios.post('user_billings/', data)
                        .then(res => {
                            this.$notify({
                                group: 'foo',
                                type: 'success',
                                text: 'افزودن با موفقیت انجام شد.'
                            });
                            if(this.form.billing_type.val == '1'){
                                this.id = res.data.id;
                            }
                            for (const key in this.form){
                                this.form[key].val = '';
                            }
                        })
                        .catch(() => {
                            this.$notify({
                                group: 'foo',
                                type: 'error',
                                text: 'خطا! لطفا مجددا تلاش کنید.'
                            });
                        })
                }
            }
            this.access = true;
        }
    },
	beforeCreate(){
        if(this.$store.state.perms.can_add_bill == false
            && this.$store.state.perms.can_add_bill_for_all_users == false
            && this.$store.state.perms.can_add_bill_for_same_group_users == false
            && this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>
